import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppRoutes from './app';




const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppRoutes />
  </React.StrictMode>
);


